// extracted by mini-css-extract-plugin
module.exports = {"actions":"incentive-actions_actions__1wMnJ"};